export function subscribeHandler() {
    
    $('#subscription-submit').on('click', function() {

        let $emailInput = $('#email-input');
        let $countrySelectInput = $('#newsletter-country');
        let country = $countrySelectInput.val() ? $countrySelectInput.val() : '';
        let emailData = $emailInput.val();
        let $statusMsg = $('.footer-paragraph.status-info');
        $statusMsg.css({"visibility": "hidden"});
        const data = {email: emailData, country: country};

        $.ajax({
            type: 'POST',
            url: '/public-api/subscribe',
            data: data,
            success: function(data) {
                if (data.success) {
                    $statusMsg.text('Uspešno ste se prijavili na newsletter');
                    $statusMsg.css({"visibility": "visible"});
                    $emailInput.val("");
                } else {
                    $statusMsg.text('Došlo je do greške. Molimo vas pokušajte kasnije');
                    $statusMsg.css({"visibility": "visible"});
                    $emailInput.val("");
                }
            },
            error: function(error) {
                if(error.responseJSON.errors) {
                    $statusMsg.text(error.responseJSON.errors.email[0]);
                    $statusMsg.css({"visibility": "visible"});
                }
            }
        });
    });
}